import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ImportCsvComponent } from './import-csv.component';
import { DirectivesModule } from '../directives/directives.module';
import { FileSelectImporterComponent } from './file-select-importer/file-select-importer.component';
import { ResourceMappingComponent } from './resource-mapping/resource-mapping.component';
import { ActivityTypeMappingComponent } from './activity-type-mapping/activity-type-mapping.component';
import { OrderTaskMappingComponent } from './order-task-mapping/order-task-mapping.component';
import { SummaryComponent } from './summary/summary.component';

@NgModule({
  declarations: [ImportCsvComponent,
    ResourceMappingComponent,
    FileSelectImporterComponent,
    ActivityTypeMappingComponent,
    OrderTaskMappingComponent,
    SummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  exports: [ImportCsvComponent]
})
export class ImportCsvModule {
  customElementComponent: Type<any> = ImportCsvComponent;
}
